import React, { useCallback, useState, useRef } from 'react';
import styled from 'styled-components';
import { LoginContentWrapper } from 'app/views/login/LoginContentWrapper';
import { observer } from 'mobx-react';
import { LoginBackgroundSafari } from 'app/views/login/components/LoginBackgroundSafari';
import { LoginBackground } from 'app/views/login/components/LoginBackground';
import { isFirefox, isSafari } from 'core/util/getBrowserType';
import { LoginBackgroundLowRes } from 'app/views/login/components/LoginBackgroundLowRes';

const LoginWrapperBase = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
`;

const LoginWrapperContentContainer = styled.div`
  z-index: 100;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;

  @media (max-width: 1068px) {
    .login-controls {
      align-items: center;
      width: 100%;
    }
    .login-promo {
      display: none;
    }
  }
`;

const BackgroundComponent = ({ lowRes, pos }) => {
  if (lowRes) {
    return <LoginBackgroundLowRes />;
  }

  if (isSafari || isFirefox) {
    return <LoginBackgroundSafari pos={pos} />;
  }
  return <LoginBackground pos={pos} />;
};

/**
 * Wraps the login experience page, establishing the background and content areas for login
 */
export const LoginWrapper = observer(({ children }) => {
  const [pos, setPos] = useState([0, 0]);
  const lowresRef = useRef(new URLSearchParams(window.location.search).get('lowres'));

  // track user's mouse pointer
  const onMouseMove = useCallback((event) => {
    setPos([event.clientX, event.clientY]);
  }, []);

  return (
    <LoginWrapperBase onMouseMove={onMouseMove}>
      <BackgroundComponent lowRes={lowresRef.current} pos={pos} />
      <LoginWrapperContentContainer>
        <LoginContentWrapper>{children}</LoginContentWrapper>
      </LoginWrapperContentContainer>
    </LoginWrapperBase>
  );
});
